
import Vue from "vue";
import { Task } from "../../models/tasks/task";
import AppWrapper from "./CalendarEventEditWrapper.vue";
import AppTaskEdit from "@/components/tasks/TaskEdit.vue";
import { FolderUser } from "../../models/tasks/folder-user";
import { TaskService } from "../../services/task-service";

export default Vue.extend({
	data(){
		return {
			folders: [] as FolderUser[]
		};
	},
	props: {
		task: {
			type: Object as ()=>Task,
			required: true
		},
		maxWidth: [String, Number]
	},
	methods: {
		async save(){
			await TaskService.putTask(this.task);
			this.$emit("deleted");
			this.cancel();
		},
		async delete(){
			await TaskService.deleteTask(this.task);
			this.$emit("saved");
			this.cancel();
		},
		cancel(){
			this.$emit("close");
		}
	},
	async created(){
		let folders = await TaskService.getFolders();
		this.folders = folders.filter(f=>f.IsOwner);
	},
	components: {
		AppWrapper,
		AppTaskEdit
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
